const authHandler = uri =>
  new Promise((resolve, reject) => {
    const { width, height } = window.screen;
    const windowWidth = 500;
    const windowHeight = parseInt(height * 0.5, 10);
    const left = (width - windowWidth) / 2;
    const top = (height - windowHeight) / 2;

    let winRef = window.open(
      uri,
      "_blank",
      //Without keyboardDisplayRequiresUserAction=no the app may become unresponsive after authentication
      `width=${windowWidth},height=${windowHeight},left=${left},top=${top},location=no,keyboardDisplayRequiresUserAction=no,presentationstyle=formsheet`
    );

    if (winRef) {
      //Sometimes the success page fail to load, therefore use loadstart instead of loadstop
      winRef.addEventListener("loadstart", ({ url }) => {
        if (/auth\/success\/$/.test(url)) {
          winRef.close();
          return resolve();
        }
        if (/auth\/error\/$/.test(url)) {
          winRef.close();
          return reject();
        }
      });
    }

    window.addEventListener("message", ({ data }) => {
      if (data.authenticated) {
        return resolve();
      } else {
        return reject();
      }
    });
  });

export default authHandler;



// WEBPACK FOOTER //
// ./src/helpers/authHandler.js